module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Regular.0589d1a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSans-Regular.eot
// module id = OnVN
// module chunks = 0